import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getGenerativeModel, getVertexAI } from 'firebase/vertexai';

const firebaseConfig = {
  apiKey: 'AIzaSyCp9WfMSB1zaYoWM6d_x9t-YNEtXX99YE8',
  authDomain: 'quizzard-c86a1.firebaseapp.com',
  projectId: 'quizzard-c86a1',
  storageBucket: 'quizzard-c86a1.firebasestorage.app',
  messagingSenderId: '627206330661',
  appId: '1:627206330661:web:55165181d30298946c22cc',
  measurementId: 'G-9EMB7VPD5N',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
const vertexAI = getVertexAI(app);
export const geminiModel = getGenerativeModel(vertexAI, {
  model: 'gemini-1.5-flash',
});
export const geminiModelPro = getGenerativeModel(vertexAI, {
  model: 'gemini-1.5-pro',
});
